<fav-tournaments></fav-tournaments>

<div class="container" *ngIf="this._UiHelper.favPreMatches.length > 0">
  <div class="header favouritematch" (click)="openFavPreMatches()">
    <div class="header-text">{{ 'Favourite' | t }} ({{ this._UiHelper.favPreMatches.length }})</div>
    <image-loader-utils url="star" extraClasses="fav-left-menu-icon"></image-loader-utils>
  </div>
</div>

<div class="container">
  <div class="header" (click)="toggleLeagueMenu()">
    <div class="header-text whiteText">
      {{ 'Top_Leagues' | t }}
    </div>
    <image-loader-utils url="up-arrow" [extraClasses]="'white-color arrow-icon ' + (isOpenLeagueMenu ? 'up' : 'down')"> </image-loader-utils>
  </div>
  <div class="content" *ngIf="isOpenLeagueMenu">
    <top-leagues></top-leagues>
  </div>
</div>
<div class="container">
  <div class="header" (click)="toggleSportsMenu()">
    <div class="header-text whiteText">
      {{ 'b3000_sports' | t }}
    </div>
    <image-loader-utils url="up-arrow" [extraClasses]="'white-color arrow-icon ' + (isOpenSportsMenu ? 'up' : 'down')"> </image-loader-utils>
  </div>
  <div class="content" *ngIf="isOpenSportsMenu">
    <ng-container *ngIf="mainData == undefined || mainData?.length < 1">
      <ngx-skeleton-loader [theme]="{ height: '19px', width: '230px', background: 'var(--white-color-300)' }" count="10"></ngx-skeleton-loader>
    </ng-container>

    <ng-container *ngFor="let item of mainData; let i = index">
      <div class="sports-menu-item">
        <div class="item-row" (click)="getCountriesBySportsID(item.SportId, i)">
          <div class="left">
            <image-loader-utils [url]="this.sportsSvgList[item.SportId]?.svgKey" extraClasses="sportmenusvg"></image-loader-utils>
          </div>
          <div class="mid">{{ item.SportName }}</div>
          <div class="right">
            <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (isOpenLeagueMenu ? 'right' : 'down')"> </image-loader-utils>
          </div>
        </div>
        <div class="item-box" *ngIf="item.state">
          <ng-container *ngFor="let item2 of mainData[i].level; let k = index">
            <div class="sports-menu-dropdown">
              <div class="sports-menu-item row country" (click)="openAll(mainData[i].level[k], item2, item, i, k)">
                <div class="left">
                  <image-loader-utils [url]="item2.IsoName" [isFlags]="true" extraClasses="flag-rounded mt"></image-loader-utils>
                </div>
                <div class="mid">{{ item2.CategoryName }}</div>
                <div class="right">{{ item2.CategoryEventCount }}</div>
              </div>
            </div>
            <div class="item-box2" *ngIf="item2.state">
              <ng-container *ngFor="let item3 of mainData[i].level[k].level; let l = index">
                <div class="menu-content-item">
                  <div class="mid" (click)="openLeague(item, item3, item2)">{{ item3.TournamentName }}</div>
                  <div class="right">
                    <div class="event-count">
                      {{ item3.TournamentSportEventCount }}
                    </div>
                    <div (click)="add2TournamentFavs(item3, item2)">
                      <image-loader-utils url="star" [extraClasses]="'star-icon ' + (item3.checked ? 'star-icon-active' : 'star-icon-disabled')"></image-loader-utils>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngFor="let item3 of mainData[i].level[k].outrights; let l = index">
                <div class="menu-content-item">
                  <div class="mid" [routerLink]="['/outright/' + item3.TournamentId]">{{ item3.TournamentName }} {{ 'SeasonBets' | t }}</div>
                  <div class="right">
                    <div class="event-count">
                      {{ item3.TournamentSportEventCount }}
                    </div>
                    <div (click)="add2TournamentFavs(item3, item2)">
                      <image-loader-utils url="star" [extraClasses]="'star-icon ' + (item3.checked ? 'star-icon-active' : 'star-icon-disabled')"></image-loader-utils>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="desktop-left-menu-button-color btn white btn-h-30" (click)="openStats('statistics')">
  <div class="btn-text">
    {{ 'Results' | t }}
  </div>
</div>
<div class="desktop-left-menu-button-color btn white mt-8 btn-h-30" (click)="openStats('livescore')">
  <div class="btn-text">
    {{ 'b3000_statistics' | t }}
  </div>
</div>
